import styled from 'styled-components';
const statusColor = {
    ONLINE : '#1e8e3e',
    PAUSA : '#fbbd05',
    OFFLINE : '#8f8f8f'
}

export const Container = styled.div`
    display: flex;
    position: relative;
    width: 9rem;
    height: 2.5rem;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;
    user-select: none;

    border-radius: 4px;
    border: 1px solid #dadce0;
    padding: .75rem;

    &:hover{
        background: ${({theme})=>theme.colors.__gray[250]};
    }

    .status__{
        display:flex;
        align-items: center;
        gap: .5rem;
    }

    .Down{
        display:flex;
        align-items: center;
        font-size:1.5rem;
    }
`;


export const IndicatorSatus = styled.div`
    border-radius: 50%;
    height: 12px;
    width: 12px;
    background-color:${({status})=> statusColor[status]};
`;


export const Options = styled.ul`
    display: ${({isOpen}) => isOpen ?'flex':'none'};
    position: absolute;
    background: #ffffff;
    list-style: none;
    flex-direction: column;
    margin: 0;
    padding: 0;
    top: 3.50rem;
    z-index: 99999999;
    width: 125px;
    border: 0 none;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);
    animation-duration: .12s;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    border-radius: 4px;
    transform-origin: center top;
    user-select: none;
    right: 27.75rem;
    li{
        display: flex;
        width: 100%;
        list-style: none;
        cursor: pointer;
        color: #495057;
        padding:0.5rem;
        padding-left:1rem;
        display: flex;
        align-items: center;
        justify-content:left;
        transition: background-color 0.2s;
        gap: .5rem;

        &:hover{
            background: ${({theme})=>theme.colors.__gray[250]};
        }

    }
`